import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHarnessOptimizerGlyph = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 25.6545,
	height: 30.32,
	viewBox: "0 0 25.6545 30.32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 3",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 46",
				cx: 12.6493,
				cy: 1.68225,
				r: 1.68225,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 47",
				cx: 23.972,
				cy: 21.0354,
				r: 1.68225,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 48",
				cx: 1.68225,
				cy: 20.6073,
				r: 1.68225,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group 1",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector 14",
						d: "M12.5053 1.68202C12.5053 9.48819 8.28839 16.6854 1.4787 20.5018L1.29032 20.6073",
						stroke: "#FBFBFB"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector 15",
						d: "M12.5051 1.68198C12.5051 9.43815 16.6693 16.5972 23.4113 20.4317L23.7201 20.6073",
						stroke: "#FBFBFB"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector 16",
						d: "M23.7203 20.6075C16.7567 16.6905 8.25395 16.6904 1.29033 20.6075",
						stroke: "#FBFBFB"
					})
				]
			})
		]
	})
});
export default SvgHarnessOptimizerGlyph;
